import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { AlbumState, UpdatedFolderType, removeFromUpdatingFolderProgress } from '../../Slice/Dashboard/AlbumSlice';
import { createFolderAPI, deleteAllFolderImagesAPI, deleteFolderAPI, deleteFolderImagesAPI, getFolderLikedImageAPIV2, getSingleFolderAPI, hideFolderAPI, lockFolderAPI, lockMultipleFoldersAPI, toggleWatermarkAPI, unlockFolderAPI, updateFolderAPI, updateFolderNameAPI } from '../../ApiCalls/Dashboard/FolderApi';
import { Folder } from '../../../Data/album.dto';
import { showErrorToast, showSuccessToast, showWarningToast } from '../../../components/atoms/Utlis/Toast';
import store from '../../Store';
import { trackClarityEvent } from '../../../analytics/ClarityAnalytics';
import { CLARITY_EVENTS } from '../../../analytics/EventTypes';

export const FolderReducer = (builder: ActionReducerMapBuilder<AlbumState>) => {

    builder.addCase(lockMultipleFoldersAPI.pending, (state) => {
        state.folderLoading = true;
    })
        .addCase(lockMultipleFoldersAPI.fulfilled, (state, action: PayloadAction<any>) => {
            state.folderLoading = false;
            state.isFolderChange = true;
            showSuccessToast("Folders successfully locked.");
        })
        .addCase(lockMultipleFoldersAPI.rejected, (state, action: PayloadAction<any>) => {
            state.folderLoading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        })
        .addCase(unlockFolderAPI.pending, (state) => {
            state.folderLoading = true;
        })
        .addCase(unlockFolderAPI.fulfilled, (state, action: PayloadAction<{ folder_id: number, project_id: number }>) => {
            state.isFolderChange = true;
            state.folderLoading = false;
            state.updatedFolderList.push(action.payload)
            showSuccessToast("Folder successfully unlocked.");
        })
        .addCase(unlockFolderAPI.rejected, (state, action: PayloadAction<any>) => {
            state.folderLoading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        })
        .addCase(createFolderAPI.pending, (state) => {
            state.folderLoading = true;
        })
        .addCase(createFolderAPI.fulfilled, (state, action: PayloadAction<{ folder_id: number, project_id: number }>) => {
            state.updatedFolderList.push(action.payload);
            state.folderLoading = false;
            showSuccessToast("Folder is successfully created.")
            trackClarityEvent(CLARITY_EVENTS.IMAGE_UPLOADED, {
                folder_id: action.payload.folder_id,
                project_id: action.payload.project_id,
                context: "folder_creation",
            })
        })
        .addCase(createFolderAPI.rejected, (state, action: PayloadAction<any>) => {
            state.folderLoading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        })
        .addCase(updateFolderAPI.pending, (state) => {

        })
        .addCase(updateFolderAPI.fulfilled, (state, action: PayloadAction<{ folder_id: number, project_id: number, uploaded?: number, failed?: number, total?: number, skippedDuplicates?: number, failedUploadDetails?: Array<{ file: string, error: string }> }>) => {
            state.updatedFolderList.push(action.payload);
            state.uploadFolderProgress = state.uploadFolderProgress.filter(folder => folder.folderId !== action.payload.folder_id)
            state.currentCompressingFolder = state.currentCompressingFolder.filter(folder => folder.folderId !== action.payload.folder_id)
            const { uploaded, failed, total, skippedDuplicates } = action.payload;
            if (failed != null && failed > 0 && total != null && uploaded != null) {
                showWarningToast(
                    `Uploaded ${uploaded} of ${total} images. ${failed} could not be uploaded — try those again.`,
                );
            } else if (skippedDuplicates != null && skippedDuplicates > 0) {
                showWarningToast(
                    `Upload complete. ${skippedDuplicates} file(s) were already in this folder and were not uploaded again.`,
                );
            } else {
                showSuccessToast("Folders updated successfully.");
            }
            trackClarityEvent(CLARITY_EVENTS.FOLDER_UPDATED, {
                folder_id: action.payload.folder_id,
                project_id: action.payload.project_id,
            })
            trackClarityEvent(CLARITY_EVENTS.IMAGE_UPLOADED, {
                folder_id: action.payload.folder_id,
                project_id: action.payload.project_id,
            })
        })
        .addCase(updateFolderAPI.rejected, (state, action: PayloadAction<any>) => {
            state.folderLoading = false;
            state.isError = true;
            state.uploadFolderProgress = state.uploadFolderProgress.filter(folder => folder.folderId !== action.payload.folder_id)
            state.currentCompressingFolder = state.currentCompressingFolder.filter(folder => folder.folderId !== action.payload.folder_id)


        })
        .addCase(getSingleFolderAPI.pending, (state) => {
            state.folderLoading = true;
        })
        .addCase(getSingleFolderAPI.fulfilled, (state, action: PayloadAction<{ folder: Folder, page: number }>) => {
            state.isFolderChange = false;
            state.folderLoading = false;
            state.updatedFolderList = state.updatedFolderList.filter(folder => folder.folder_id !== action.payload.folder.id)
            // state.currentFolder = action.payload.folder;
            if (state.currentFolder) {
                if (action.payload.page === 1 && action.payload.folder && state.currentAlbum) {
                    state.currentAlbum.folders = state.currentAlbum?.folders?.map(folder => {
                        if (folder.id === action.payload.folder.id) {
                            return action.payload.folder;
                        }
                        return folder;
                    })
                    state.currentFolder = {
                        ...state.currentFolder,
                        ...action.payload.folder,
                        images: [...action.payload.folder.images]
                    };
                }
                else {

                    state.currentFolder.images = [...state.currentFolder.images, ...action.payload.folder.images];
                }
            }
        })
        .addCase(getSingleFolderAPI.rejected, (state, action: PayloadAction<any>) => {
            state.folderLoading = false;
            state.isError = true;
            state.isFolderChange = false;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        })
        .addCase(deleteFolderImagesAPI.pending, (state) => {
            state.folderLoading = true;
        })
        .addCase(deleteFolderImagesAPI.fulfilled, (state, action: PayloadAction<{ folder_id: number, project_id: number }>) => {
            state.updatedFolderList.push(action.payload)
            state.folderLoading = false;
            showSuccessToast("Image deleted successfully.");
            trackClarityEvent(CLARITY_EVENTS.IMAGE_DELETED, {
                folder_id: action.payload.folder_id,
                project_id: action.payload.project_id,
            })

        })
        .addCase(deleteFolderImagesAPI.rejected, (state, action: PayloadAction<any>) => {
            state.folderLoading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        })
        .addCase(deleteAllFolderImagesAPI.pending, (state) => {
            state.folderLoading = true;
        })
        .addCase(deleteAllFolderImagesAPI.fulfilled, (state, action: PayloadAction<{ folder_id: number, project_id: number }>) => {
            state.updatedFolderList.push(action.payload)
            state.folderLoading = false;
            showSuccessToast("Image deleted successfully.");
            trackClarityEvent(CLARITY_EVENTS.IMAGE_DELETED, {
                folder_id: action.payload.folder_id,
                project_id: action.payload.project_id,
                delete_all: true,
            })

        })
        .addCase(deleteAllFolderImagesAPI.rejected, (state, action: PayloadAction<any>) => {
            state.folderLoading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        })
        .addCase(deleteFolderAPI.pending, (state) => {
            state.folderLoading = true;
        })
        .addCase(deleteFolderAPI.fulfilled, (state, action: PayloadAction<{ folder_id: number, project_id: number }>) => {
            state.folderLoading = false;
            state.updatedFolderList.push(action.payload)
            showSuccessToast("Folder Deleted.");


        })
        .addCase(deleteFolderAPI.rejected, (state, action: PayloadAction<any>) => {
            state.folderLoading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        })
        .addCase(hideFolderAPI.pending, (state) => {
            state.folderLoading = true;
        })
        .addCase(hideFolderAPI.fulfilled, (state, action: PayloadAction<{ folder_id: number, project_id: number }>) => {
            state.updatedFolderList.push(action.payload)
            state.folderLoading = false;
            showSuccessToast("Folder's status updated successfully.");
        })
        .addCase(hideFolderAPI.rejected, (state, action: PayloadAction<any>) => {
            state.folderLoading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        }).addCase(lockFolderAPI.pending, (state) => {
            state.folderLoading = true;
        }).addCase(lockFolderAPI.fulfilled, (state, action: PayloadAction<{ folder_id: number, project_id: number }>) => {
            state.updatedFolderList.push(action.payload)
            state.folderLoading = false;
            showSuccessToast("Folder's status updated successfully.");
        })
        .addCase(lockFolderAPI.rejected, (state, action: PayloadAction<any>) => {
            state.folderLoading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        }).addCase(toggleWatermarkAPI.pending, (state) => {
            state.folderLoading = true;
        }).addCase(toggleWatermarkAPI.fulfilled, (state, action: any) => {
            state.updatedFolderList.push(action.payload)
            state.folderLoading = false;
            const activate = action.meta.arg.add_watermark === 'True';
            if (state.currentFolder && state.currentFolder.id === action.payload.folder_id) {
                state.currentFolder.activate_watermark = activate;
            }
            if (state.currentAlbum && state.currentAlbum.folders) {
                state.currentAlbum.folders = state.currentAlbum.folders.map(folder => {
                    if (folder.id === action.payload.folder_id) {
                        return { ...folder, activate_watermark: activate };
                    }
                    return folder;
                });
            }
            state.albums.forEach(album => {
                if (album.folders) {
                    album.folders = album.folders.map(folder => {
                        if (folder.id === action.payload.folder_id) {
                            return { ...folder, activate_watermark: activate };
                        }
                        return folder;
                    });
                }
            });
            showSuccessToast("Watermark status updated.");
        })
        .addCase(toggleWatermarkAPI.rejected, (state, action: PayloadAction<any>) => {
            state.folderLoading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        }).addCase(updateFolderNameAPI.pending, (state) => {
            state.folderLoading = true;
        }).addCase(updateFolderNameAPI.fulfilled, (state, action: PayloadAction<{ folder_id: number, project_id: number }>) => {

            state.folderLoading = false;
            state.updatedFolderList.push(action.payload);
            state.uploadFolderProgress = state.uploadFolderProgress.filter(folder => folder.folderId !== action.payload.folder_id)

            showSuccessToast("folder name  updated.");
            trackClarityEvent(CLARITY_EVENTS.FOLDER_UPDATED, {
                folder_id: action.payload.folder_id,
                project_id: action.payload.project_id,
            })
        })
        .addCase(updateFolderNameAPI.rejected, (state, action: PayloadAction<any>) => {
            state.folderLoading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message)
            } else {
                console.log(action.payload)
            }
        })
};

